import { Button } from '@/components/ui/button'
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from '@/components/ui/drawer'
import { Kbd } from '@/components/ui/kbd'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { useHotKey } from '@/hooks/use-hot-key'
import { useMediaQuery } from '@/hooks/use-media-query'
import { getModifierKey } from '@/lib/platform'
import { VisuallyHidden } from 'radix-ui'
import { FilterIcon } from 'lucide-react'
import React from 'react'
import { DataTableFilterApplyButton } from './data-table-filter-apply-button'
import { DataTableFilterControls } from './data-table-filter-controls'

export function DataTableFilterControlsDrawer() {
  const triggerButtonRef = React.useRef<HTMLButtonElement>(null)
  const isMobile = useMediaQuery('(max-width: 640px)')
  const [open, setOpen] = React.useState(false)

  useHotKey(() => setOpen((prev) => !prev), 'b')

  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <TooltipProvider>
        <Tooltip delayDuration={100}>
          <TooltipTrigger asChild>
            <Button
              ref={isMobile ? triggerButtonRef : null}
              variant="ghost"
              size="icon"
              className="h-9 w-9"
              onClick={() => setOpen((prev) => !prev)}>
              <FilterIcon className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent side="right">
            <p>
              Toggle controls with{' '}
              <Kbd className="text-muted-foreground group-hover:text-accent-foreground ml-1">
                <span className="mr-1">{getModifierKey()}</span>
                <span>B</span>
              </Kbd>
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <DrawerContent className="max-h-[calc(100dvh-4rem)]">
        <VisuallyHidden.Root>
          <DrawerHeader>
            <DrawerTitle>Filters</DrawerTitle>
            <DrawerDescription>Adjust your table filters</DrawerDescription>
          </DrawerHeader>
        </VisuallyHidden.Root>
        <div className="min-h-0 flex-1 overflow-y-auto px-4">
          <DataTableFilterControls />
        </div>
        <DrawerFooter>
          <DataTableFilterApplyButton onApplied={() => setOpen(false)} />
          <DrawerClose asChild>
            <Button variant="outline" className="w-full">
              Close
            </Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  )
}
